import React from "react";
export default class PrePostComponenant extends React.Component {
    constructor(opts) {
        super(opts);
        this.state = {
            colorcode: {}
        }
    }
    getPrePostColorCodeForThreat = (value) => {
        let colorStr = {};
        try{
            if(this.props.HeatMapConfigDataThreat){
                // let value="0-10L"; // [7,2]
                let HeatMapConfigDataThreat=this.props.HeatMapConfigDataThreat? JSON.parse(JSON.stringify(this.props.HeatMapConfigDataThreat)):[];
                let dynamicHeatmapProbabilityRangeX=this.props.dynamicHeatmapProbabilityRange?[...this.props.dynamicHeatmapProbabilityRange]:[];
                let dynamicHeatmapProbabilityRangeY=this.props.dynamicHeatmapProbabilityRange?[...this.props.dynamicHeatmapProbabilityRange].reverse():[];
    
                let prob=value?.split(/[a-zA-Z]/g)[0];//without a-z ex.0-19
                let abbreviation=value?.split(prob)[1];//abbreviation ex.L
                let probabilityRangeValue=parseInt(prob?.split("-")[1]);
    
                let pobObj=dynamicHeatmapProbabilityRangeX.find((item)=>item.abbreviation===abbreviation);
                let probOrderId=pobObj?.orderId-1;//probablity index ex.2
                let rowidex=dynamicHeatmapProbabilityRangeY.findIndex((item)=>item.probabilityRangeValue===(probabilityRangeValue+1));
                let HeatMapConfigDataThreatColorObj=HeatMapConfigDataThreat[rowidex+1]?.row[probOrderId] || HeatMapConfigDataThreat[dynamicHeatmapProbabilityRangeY?.length-1]?.row[0];

                colorStr = {
                    backgroundColor: HeatMapConfigDataThreatColorObj?.colorCode,
                    color: HeatMapConfigDataThreatColorObj?.colorCode,
                    display: "flex",
                    height: "12px",
                    width: "12px",
                    borderRadius: "50%",
                    margin: "0px auto",
                    alignItems: "center",
                    justifyContent: "center",
                  };
            }
           
        }catch(err){
            console.error(err);
        }
        return colorStr;
    }

    getPrePostColorCodeForOpp = (value) => {
        let colorStr = {};
        try{
            if(this.props.HeatMapConfigDataOpportunity){
                // let value="0-10L"; // [7,2]
                let HeatMapConfigDataOpportunity=this.props.HeatMapConfigDataOpportunity? JSON.parse(JSON.stringify(this.props.HeatMapConfigDataOpportunity)):[];
                let dynamicHeatmapProbabilityRangeX=this.props.dynamicHeatmapProbabilityRange?[...this.props.dynamicHeatmapProbabilityRange].reverse():[];
                let dynamicHeatmapProbabilityRangeY=this.props.dynamicHeatmapProbabilityRange?[...this.props.dynamicHeatmapProbabilityRange].reverse():[];
    
                let prob=value?.split(/[a-zA-Z]/g)[0];//without a-z ex.0-19
                let abbreviation=value?.split(prob)[1];//abbreviation ex.L
                let probabilityRangeValue=parseInt(prob?.split("-")[1]);
    
                let probOrderId=dynamicHeatmapProbabilityRangeX.findIndex((item)=>item.abbreviation===abbreviation);
                // let probOrderId=parseInt(pobObj?.orderId===1?pobObj.orderId:pobObj?.orderId-1||0);//probablity index ex.2
                let rowidex=dynamicHeatmapProbabilityRangeY.findIndex((item)=>item.probabilityRangeValue===(probabilityRangeValue+1));
                let HeatMapConfigDataOpportunityObj=HeatMapConfigDataOpportunity[rowidex+1]?.row || HeatMapConfigDataOpportunity[dynamicHeatmapProbabilityRangeX?.length-1]?.row;//get row
                let colorRow=HeatMapConfigDataOpportunityObj[probOrderId] || HeatMapConfigDataOpportunityObj[0];
                colorStr = {
                    backgroundColor: colorRow?.colorCode,
                    color: colorRow?.colorCode,
                    display: "flex",
                    height: "12px",
                    width: "12px",
                    borderRadius: "50%",
                    margin: "0px auto",
                    alignItems: "center",
                    justifyContent: "center",
                  };
            }
           
        }catch(err){
            console.error(err);
        }
        return colorStr;
    }

    componentDidMount = () => {
       
    }

    render() {
        const value = this.props.dataItem[this.props.field];
        let clrCode={};
        if(this.props.dataItem.isOpportunity==="Threat"){
            clrCode=this.getPrePostColorCodeForThreat(value)
        }
        else{
            clrCode= this.getPrePostColorCodeForOpp(value)
        }
        return (
            <td>
                <span title ={value}  >
                    <p style={clrCode}>&nbsp;</p>
                </span>
            </td>
        );
    }
}
